import { render, staticRenderFns } from "./account-settings.vue?vue&type=template&id=5232ab2b"
import script from "./account-settings.vue?vue&type=script&lang=js"
export * from "./account-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports